import { isObject } from "lodash";

export default (state, { payload = {} }) =>
  isObject(payload) && Object.keys(payload).length
    ? {
        ...state,
        ...payload,
      }
    : state;



// WEBPACK FOOTER //
// ./reducers/helpers/standardReducer.js